module.exports = __webpack_public_path__ + "img/gh.6ad2b9cb.svg";